import { cn } from "@/lib/utils";

interface StepProgressBarProps {
  currentStep: number;
  totalSteps: number;
  className?: string;
}

export function StepProgressBar({ currentStep, totalSteps, className }: StepProgressBarProps) {
  return (
    <div className={cn("flex gap-1", className)}>
      {Array.from({ length: totalSteps }, (_, index) => {
        const stepNumber = index + 1;
        const isCompleted = stepNumber <= currentStep;
        
        return (
          <div
            key={stepNumber}
            className={cn(
              "flex-1 rounded-full transition-colors",
              isCompleted 
                ? "bg-primary" 
                : "bg-secondary"
            )}
          />
        );
      })}
    </div>
  );
}

